import { FadeIn } from "./FadeIn";
import { Logo } from "./Logo";
import { OpenStatus } from "./OpenStatus";
import { Phone, Clock, Star } from "lucide-react";
import { TEL_LINK, WA_LINK, PHONE_FORMATTED, GOOGLE_MAPS_LINK } from "../constants/contact";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
  </svg>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-slate-800/80 bg-[#05080D] overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute top-0 left-1/2 -translate-x-1/2 w-[720px] h-[320px] bg-amber-500/10 blur-[130px] rounded-full"
    />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 text-center">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-300 mb-5">
          7/24 Acil Elektrik Servisi
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-6xl lg:text-7xl text-slate-50 leading-[1.05]">
          ARIZANIZ MI VAR?
          <span className="block text-amber-400 drop-shadow-[0_0_30px_rgba(245,158,11,0.35)]">
            BİR TIKLA ULAŞIN.
          </span>
        </h2>
      </FadeIn>

      <FadeIn delay={0.15}>
        <div className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4">
          <a
            href={TEL_LINK}
            data-testid="footer-call-button"
            className="inline-flex items-center justify-center gap-3 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-display font-bold text-lg px-9 py-4 transition-colors duration-200 shadow-[0_0_36px_rgba(245,158,11,0.4)]"
          >
            <Phone className="w-5 h-5" strokeWidth={2.5} />
            {PHONE_FORMATTED}
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-button"
            className="inline-flex items-center justify-center gap-3 rounded-full bg-green-500 hover:bg-green-400 text-black font-display font-bold text-lg px-9 py-4 transition-colors duration-200"
          >
            <WhatsAppIcon className="w-5 h-5" />
            WHATSAPP
          </a>
        </div>
      </FadeIn>

      <FadeIn delay={0.2}>
        <a
          href={GOOGLE_MAPS_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-google-review-button"
          className="group mt-8 inline-flex items-center justify-center gap-3 rounded-full border border-slate-600 bg-transparent hover:border-amber-400/60 hover:bg-amber-500/10 text-slate-200 hover:text-amber-300 font-display font-semibold text-sm px-7 py-3 transition-colors duration-200"
        >
          <Star className="w-4 h-4 text-amber-400" fill="currentColor" />
          GOOGLE'DA BİZE YORUM YAPIN
        </a>
      </FadeIn>

      <FadeIn delay={0.25}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-3">
          <OpenStatus />
          <span className="inline-flex items-center gap-2.5 text-slate-400">
            <Clock className="w-4 h-4 text-amber-400" strokeWidth={2.25} />
            <span className="font-mono text-xs tracking-[0.18em] uppercase">
              Hafta içi & hafta sonu · 08:00 – 23:00 · Acil durumlarda 7/24
            </span>
          </span>
        </div>
      </FadeIn>

      <div className="mt-16 pt-8 border-t border-slate-800/70 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Logo size={30} />
          <span className="font-display font-bold text-sm text-slate-300 tracking-tight">
            Beylikdüzü Elektrikçi
          </span>
        </div>
        <p className="font-mono text-[11px] tracking-[0.15em] text-slate-500 uppercase">
          İstanbul / Beylikdüzü · Garantili Ustalık
        </p>
      </div>
    </div>
  </footer>
);
